import axios from 'axios';

/** Pulls a user-readable message from DRF-style error payloads or falls back to a generic copy. */
export const resolveQueueErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as unknown;

    if (typeof data === 'string' && data.trim().length > 0) {
      return data;
    }

    if (data && typeof data === 'object') {
      const record = data as Record<string, unknown>;
      const detail = record.detail ?? record.message;
      if (typeof detail === 'string' && detail.trim().length > 0) {
        return detail;
      }

      const firstFieldError = Object.values(record).find(
        value =>
          (typeof value === 'string' && value.trim().length > 0) ||
          (Array.isArray(value) && value.some(entry => typeof entry === 'string' && entry.trim().length > 0)),
      );

      if (typeof firstFieldError === 'string') {
        return firstFieldError;
      }
      if (Array.isArray(firstFieldError)) {
        const firstString = firstFieldError.find((entry): entry is string => typeof entry === 'string' && entry.trim().length > 0);
        if (firstString) {
          return firstString;
        }
      }
    }

    if (!error.response) {
      return 'Nie udało się połączyć z serwerem. Sprawdź połączenie i spróbuj ponownie.';
    }
  }

  return 'Nie udało się utworzyć kolejki. Spróbuj ponownie.';
};
